var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelSelectedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.4141 4.13773C7.85227 4.13773 4.13867 7.85132 4.13867 12.4131C4.13867 16.975 7.85227 20.6886 12.4141 20.6886C16.9759 20.6886 20.6895 16.975 20.6895 12.4131C20.6895 7.85132 16.9759 4.13773 12.4141 4.13773ZM16.5518 15.0923L15.0933 16.5509L12.4141 13.8717L9.73493 16.5509L8.27638 15.0923L10.9556 12.4131L8.27638 9.73398L9.73493 8.27544L12.4141 10.9546L15.0933 8.27544L16.5518 9.73398L13.8726 12.4131L16.5518 15.0923Z",
    fill: "#FF3636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0918 8.27541L12.4126 10.9546L9.73347 8.27541L8.27493 9.73396L10.9541 12.4131L8.27493 15.0923L9.73347 16.5508L12.4126 13.8717L15.0918 16.5508L16.5503 15.0923L13.8712 12.4131L16.5503 9.73396L15.0918 8.27541ZM12.4126 2.06885C6.69225 2.06885 2.06836 6.69274 2.06836 12.4131C2.06836 18.1335 6.69225 22.7574 12.4126 22.7574C18.133 22.7574 22.7569 18.1335 22.7569 12.4131C22.7569 6.69274 18.133 2.06885 12.4126 2.06885ZM12.4126 20.6885C7.85081 20.6885 4.13721 16.9749 4.13721 12.4131C4.13721 7.8513 7.85081 4.1377 12.4126 4.1377C16.9745 4.1377 20.6881 7.8513 20.6881 12.4131C20.6881 16.9749 16.9745 20.6885 12.4126 20.6885Z",
    fill: "#FF3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSelectedFile);
export default __webpack_public_path__ + "static/media/cancel_selected_file.e5850c0435f6af2dddb09490b75bf041.svg";
export { ForwardRef as ReactComponent };